module.exports = __webpack_public_path__ + "static/img/pic_toptitlle_cpraedjz@2x.5c39d65a.png";